import classNames from 'classnames/bind';
import React from 'react';
import NoResults from '../../../components/NoResults';
import style from './NoSearchResults.module.scss';

const cx = classNames.bind(style);

const NoSearchResults = (): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <NoResults infoText="Please update search criteria." />
    </div>
  );
};

export default NoSearchResults;
